<!--
 * @Auther: 罗耀祖
 * @Date: 2022-04-20 15:31:09
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-10-08 17:52:01
 * @name: 预览(图片、视频)
 * @Description: 预览(图片、视频)
 * @FilePath: \project\src\components\public\big-preview.vue
 * @Author: desktop
-->
<template>
  <div class="bigPreview-floating" v-if="show" @click="show = false">
    <img
      class="arrow-left"
      src="@/assets/icon/arrow-left-grayback.png"
      @click.stop="prev"
      v-if="index > 0"
    />
    <div class="container">
      <template v-if="urls[index].indexOf('video') > -1">
        <video class="preview-video" controls autoplay @click.stop>
          <source :src="urls[index]" />
        </video>
      </template>
      <template v-else>
        <img
          class="preview-img"
          :style="{ zoom: scaleSizeNum }"
          :src="urls[index]"
          :onerror="errorimg"
          @click.stop
        />
      </template>
      <div class="control" @click.stop>
        <i
          class="el-icon-zoom-in"
          @click.stop="scaleSizeNum < 2 && (scaleSizeNum = scaleSizeNum + 0.2)"
        ></i>
        <i
          class="el-icon-zoom-out"
          @click.stop="scaleSizeNum > 1 && (scaleSizeNum = scaleSizeNum - 0.2)"
        ></i>
      </div>
    </div>
    <img
      class="arrow-right"
      src="@/assets/icon/arrow-left-grayback.png"
      @click.stop="next"
      v-if="index < urls.length - 1"
    />
  </div>
</template>
<script>
export default {
  name: "bigPreview",
  data() {
    return {
      index: 0,
      urls: [], //图片地址
      show: false, //是否展示
      errorimg: 'this.src="' + require("@/assets/image/no-img.png") + '"',
      scaleSizeNum: 1,
    };
  },
  computed: {
    scaleSize() {
      return `scale(${this.scaleSizeNum})`;
    },
  },
  watch: {
    show: {
      handler(nv, ov) {
        if (!nv) {
          this.close();
        }
      },
      immediate: false,
      deep: true,
    },
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 展示图片
     * @param {Array} urls 地址数组
     * @param {Number} index 索引
     */
    open(urls, index = 0) {
      this.urls = urls;
      this.index = index;
      this.show = true;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 关闭执行
     */
    close() {
      this.index = 0;
      this.scaleSizeNum = 1;
      this.urls = [];
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 下一张
     */
    next() {
      this.index++;
    },
    prev() {
      this.index--;
    },
  },
};
</script>
<style lang="scss" scoped>
.bigPreview-floating {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  .arrow-left {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 30px;
    width: 50px;
    height: 50px;
    cursor: pointer;
    z-index: 1;
  }
  .container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 10px 0;
    background: $Var-floating-color;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    overflow: auto;
    .preview-img {
      margin: auto 0;
      max-width: 500px;
    }
    .preview-video {
      margin: auto 0;
      max-width: 500px;
    }
  }
  .arrow-right {
    position: absolute;
    top: 50%;
    transform: translateY(-50%) rotate(180deg);
    right: 30px;
    width: 50px;
    height: 50px;
    cursor: pointer;
    z-index: 1;
  }
}
.control {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background: white;
  padding: 5px;
  i {
    padding: 3px;
    &:not(:first-child) {
      margin-left: 10px;
    }
    cursor: pointer;
  }
}
</style>